export default __webpack_public_path__ + "static/media/phone_resume.eea565c3.svg";